export enum FilterValueType {
  None = 0,
  SingleValue = 1,
  ListValue = 2,
  BoundedValue = 3
}
